<div class="table-layout">
  <ion-grid class="p-0 h100vh">
    <ion-row class="p-0 mb-5" *ngIf="gridData.tabsData.length!=0">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="borderbottomForTab">
          <mat-tab-group [selectedIndex]="selectedTypeTabIndex" (selectedTabChange)="tabTypeChanged($event)">
            <mat-tab *ngFor="let item of gridData.tabsData">
              <ng-template mat-tab-label>
                <span style="display: contents;" *ngIf="item.label != 'Change Password'">
                  <span class="material-icons mr-10">
                    {{item.icons}}
                  </span>{{item.label}} ({{item.totalCount}})</span>
                <span style="display: contents;" *ngIf="item.label == 'Change Password'">
                  <span class="material-icons mr-10">
                    {{item.icons}}
                  </span>{{item.label}}</span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="p-0 mb-5" *ngIf="gridData.countTabs.length!=0">
      <ion-col class="tabsCard" [ngClass]="{'mr-15': !isLast}" *ngFor="let item of gridData.countTabs;let isLast=last">
        <ion-row class="p-0">
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="center-content p-0">
            <label class="formLabelSemiBoldfs14">{{item.tabsName}}</label>
          </ion-col>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="center-content justify-content-flex-end p-0">
            <label class="font_semibold fs-18" [style.color]="item.color" color>{{item.count}}</label>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-row class="p-0 mb-10">
      <ion-col class="p-0 display-space-between" size="12">
        <div class="horizontal-center verticle-center">
          <img *ngIf="gridData.showBackBtn" src="././assets/icon/backArrow.svg" class="cp mr-10"
            (click)="backBtn()">
          <ion-label class="font_bold fs-16 black_color" *ngIf="gridData?.showTitle">{{TableName}}
            ({{gridData.totalCount}})</ion-label>
            <ion-label class="font_bold black_color" *ngIf="gridData?.showBreadCrumbs"><span class="cp"
              >Configuration</span>&nbsp;>&nbsp;<span class="cp"
             >UA/UC Configuration</span>&nbsp;>&nbsp;<span [style.color]="buttonColorName">234</span></ion-label>
        </div>
        <div class="d-flex">
          <button *ngIf="gridData?.showExportBtn" type="button" class="exportToExcel_btn fs-14 font_medium ml-5"><span
              class="d-inline-flex" (click)="exportReport()"><img class="mr-5"
                src="././assets/icon/exportIcon.svg">Export</span></button>
          <button *ngIf="gridData?.showImportBtn" type="button" class="import_btn fs-14 ml-5"><span
              class="d-inline-flex" (click)="importReport()"><img class="mr-5"
                src="././assets/icon/importIcon.svg">Import</span></button>
          <button *ngIf="gridData?.showAddBtn" type="button" class="add_btn fs-14 ml-10"
            [style.background-color]="buttonColorName" (click)="addRecord()">+ Add New</button>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="gridData.tabsMainData.length!=0">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0 mt-10 mb-10">
        <mat-tab-group class="whiteBox demo-tab-group" [selectedIndex]="selectedStatusTabIndex"
          (selectedTabChange)="tabStatusChanged($event)">
          <mat-tab *ngFor="let item of gridData.tabsMainData" label="{{item.label}} ({{item.totalCount}})">
          </mat-tab>
        </mat-tab-group>
      </ion-col>
    </ion-row>
    <!-- nested Tabs -->
    <div class="d-flex">
      <img *ngIf="gridData.showBackBtn && gridData.showAuditLog" src="././assets/icon/forgetback.png" class="cp"
        (click)="backBtn()">
      <label *ngIf="gridData.showAuditLog" class="font_medium fs-16 ml-10 mt-5">{{TableName}}<span class="red-cl"
          *ngIf="observationNumber!=null">&nbsp;>&nbsp;{{observationNumber}}</span></label>
    </div>
    <ion-row class="p-0 mb-10 verticle-center">
      <ion-col *ngIf="gridData.showAuditLog" size-sm="7" size-md="7" size-lg="7" size-xs="7">
        <ion-label class="font_bold">{{auditLogName}}</ion-label>
      </ion-col>
      <ion-col size-sm="10" size-md="10" size-lg="10" size-xs="10">
        <div class="d-flex">
          <label *ngIf="mulipleSelect.length>0 || selectAllCheckbox" class="verticle-center">
            <button class="import_btn link fs-14 font_semibold verticle-center mr-15" *ngIf="gridData.showRestoreBtn"
              (click)="restoreData()">
              <span class="material-icons mr-5">settings_backup_restore</span>
              Restore</button>
          </label>
          <label *ngIf="mulipleSelect.length>0 || selectAllCheckbox" class="verticle-center">
            <button class="delete_btn fs-14 font_semibold verticle-center mr-15"
              *ngIf="gridData.showPermantDeleteBtn && isPerDeleteFlag" (click)="deleteMultipleRecords()">
              <span class="material-icons mr-5">delete</span>Delete</button>
          </label>
          <label *ngIf="mulipleSelect.length>0 || selectAllCheckbox" class="verticle-center">
            <button class="delete_btn fs-14 font_semibold verticle-center mr-15"
              *ngIf="gridData.showDeleteBtn && isPerDeleteFlag" (click)="deleteMultipleRecords()"><span
                class="material-icons mr-5">delete</span>Delete</button>
          </label>
          <mat-form-field *ngIf="gridData.showSearchBar" class="pr-5 mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch()">
          </mat-form-field>
          <div *ngIf="gridData.showRefreshFunctinallity">
            <ion-label class="fs-14 font_medium pr-10 black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedRange" placeholder="Select"
                (selectionChange)="onSelectCount($event)">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 font_medium pl-10 black_color">entries</ion-label>
            <img class="refreshIcon ml-10 cp" src="././assets/icon/refresh.png" (click)="refreshData()">
          </div>
        </div>
      </ion-col>
      <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="display-end">
        <!-- <ul class="dt_pagination">
          <ion-row class="float-right pgintn">
            <li class="fs-16">{{currentPage}}</li>
            <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
            <li class="fs-24 cp" (click)="previousPage()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
            <li class="fs-24 cp" (click)="nextPage()" [ngClass]="{'disableBtn': currentPage== gridData.totalNoOfPages}">
              &gt;</li>
          </ion-row>
        </ul> -->
      </ion-col>
    </ion-row>
    <div class="tableBox mt-10">
      <ion-row class="p-0">
        <table class="hover">
          <thead class="bg-gray">
            <tr>
              <th *ngIf="gridData.showCheckBox" class="mat-checkbox-style">
                <mat-checkbox [(ngModel)]="selectAllCheckbox" [checked]="selectAllCheckbox==true" value=true
                  (change)="selectALLRecords($event)"></mat-checkbox>
              </th>
              <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                <div class="verticle-center icon-style">{{item.label}}
                  <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                    <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                      (click)="onSortAssending(item)">arrow_drop_up</i>
                    <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                      (click)="onSortDesending(item)">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="bg-white" *ngIf="renderData.length !== 0">
            <tr *ngFor="let item of renderData;let i=index">
              <td *ngIf="gridData.showCheckBox" [ngClass]="{'isUserMD': item.isEmployeeMD}" class="mat-checkbox-style">
                <mat-checkbox [(ngModel)]="item.checkboxCheck"
                  (change)="selectSingleRecord($event,item,i)"></mat-checkbox>
              </td>
              <ng-container *ngFor="let innerItem of item">
                <td *ngIf="innerItem.key === 'linkName'"  [ngClass]="{'isUserMD': item.isEmployeeMD}" class="fs-14 font_regular text-blue">
                  <span (click)="showDetails(item)" class="cp">{{innerItem.value}}</span>
                </td>
                <td  [ngClass]="{'isUserMD': item.isEmployeeMD}" *ngIf="innerItem.key !== 'action' && innerItem.key !== 'id' && innerItem.key !== 'linkName' 
                && innerItem.key !== 'Total' && innerItem.key !== 'Add' && innerItem.key !== 'Update'
                && innerItem.key !== 'Skip' && innerItem.key !== 'importedHistroyDetails'
                && innerItem.key !== 'modules' && innerItem.key !== 'viewDetails'" class="fs-14 font_regular cl-black">
                  {{innerItem.value}}
                </td>
                <td *ngIf="innerItem.key === 'checkBox'">
                  <mat-checkbox [(ngModel)]="innerItem.value" disabled class="mat-checkbox-style"></mat-checkbox>
                </td>
                <td *ngIf="innerItem.key === 'Total' || innerItem.key === 'Add' 
                || innerItem.key === 'Update' || innerItem.key === 'Skip'" class="fs-14 font_regular link">
                  <span class="cp" (click)="showDetailsWithColumn(item,innerItem.key)">({{innerItem.value}})</span>
                </td>
                <td *ngIf="innerItem.key === 'modules'" class="fs-14 font_regular">
                  <span *ngIf="innerItem.value?.length>0">{{innerItem.value[0]?.moduleName}}</span>
                  <span *ngIf="innerItem.value?.length>1">&nbsp;+<u class="link cp"
                    (click)="showDetailsOfAccessMatrix(innerItem.value,'Modules List',innerItem)">{{innerItem.value?.length - 1}}</u></span>
                </td>
                <td *ngIf="innerItem.key === 'viewDetails'" class="fs-14 font_regular link">
                  <u (click)="showDetailsOfAccessMatrix(innerItem.value,'Access',innerItem)" class="cp">View Details</u>
                </td>
                <td  [ngClass]="{'isUserMD': item.isEmployeeMD}" *ngIf="innerItem.key === 'action'">
                  <img *ngIf="showSpecificButtons(innerItem,'filter')" (click)="filterDetail(item)"
                    class="cp imgFilter mr-5" src="././assets/icon/filterIcon.svg">
                  <img *ngIf="showSpecificButtons(innerItem,'edit')" (click)="editDetail(item)"
                    class="mr-5 cp imgdelete" src="././assets/icon/edit.png">
                  &nbsp;&nbsp;
                  <img *ngIf="showSpecificButtons(innerItem,'delete')" (click)="deleteDetail(item)" class="cp imgdelete"
                    src="././assets/icon/delete.png">
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
        <ion-row class="mt-5 mb-5" *ngIf="renderData.length != 0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
              <ion-label class="fs-14 font_bold black_color">Showing {{showingCount}} to {{showingOfCount}} of {{gridData.totalCount}} entries</ion-label>
          </ion-col>
      </ion-row>
      </ion-row>
      <ion-row class="bg-white display-center" *ngIf="renderData.length === 0">
        <div class="pt-50 pb-40 fs-16 font_medium cl-black">No Data Available</div>
      </ion-row>
    </div>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
      <ul class="dt_pagination">
        <ion-row class="float-right pgintn">
          <li class="fs-16">{{currentPage}}</li>
          <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
          <li class="fs-24 cp" (click)="previousPage()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
          <li class="fs-24 cp" (click)="nextPage()" [ngClass]="{'disableBtn': currentPage== gridData.totalNoOfPages}">
            &gt;</li>
        </ion-row>
      </ul>
    </ion-col>
    <div class="clear100"></div>
    <div class="clear20"></div>
  </ion-grid>
</div>